import { render, staticRenderFns } from "./SystemAlert.vue?vue&type=template&id=b48607d8&scoped=true"
import script from "./SystemAlert.vue?vue&type=script&lang=js"
export * from "./SystemAlert.vue?vue&type=script&lang=js"
import style0 from "./SystemAlert.vue?vue&type=style&index=0&id=b48607d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48607d8",
  null
  
)

export default component.exports